import { COLORS } from '@constants';
import { css } from 'styled-components';

export const sharedTypographyStyles = css`
    margin: 0;
    color: ${({ $color }) => $color || COLORS.$gray100Black};
    text-align: ${({ $align }) => $align || 'left'};

    ${({ $marginBottom }) =>
        $marginBottom &&
        css`
            margin-bottom: ${$marginBottom};
        `};
`;
